<script setup lang="ts">
import { computed, h } from "vue";
import type { VNodeChild } from "vue";
import { parseRichText } from "@dashboard/utils/parseRichText";
import type { RichTextNode } from "@dashboard/utils/parseRichText";

const props = withDefaults(defineProps<{
  html: string;
  as?: "div" | "span";
}>(), { as: "div" });

const nodes = computed(() => parseRichText(props.html));

function renderNode(node: RichTextNode, index: number): VNodeChild {
  if (typeof node === "string") return node;
  return h(node.tag, { ...node.props, key: index }, node.children.map(renderNode));
}

// Dynamic nested formatting is rendered as VNodes, never through innerHTML.
const Content = () => nodes.value.map(renderNode);
</script>

<template>
  <component :is="props.as" class="rich-text">
    <Content />
  </component>
</template>
